import { createContext, useContext, useState } from 'react';
import { ApplicationStep } from '../graphql';
import { AnalyticsEventStepPayload } from './types';

const SetAnalyticsPropertiesProvider = createContext<any>(null);

type EventPropertiesType = {
  data: Partial<AnalyticsEventStepPayload> | null;
  page: ApplicationStep;
}[];

export const AnalyticsProvider = ({ children }) => {
  const [eventProperties, setEventProperties] = useState<EventPropertiesType>([]);

  return (
    <SetAnalyticsPropertiesProvider.Provider
      value={{
        setEventProperties,
        eventProperties,
      }}
    >
      {children}
    </SetAnalyticsPropertiesProvider.Provider>
  );
};

export const useAnalyticsActions = () => {
  const context = useContext(SetAnalyticsPropertiesProvider);

  if (!context) {
    throw new Error('useAnalyticsActions must be used within a AnalyticsProvider');
  }

  return context;
};
